export const FIELD_NAMES = {
  TYPE: 'selectType',
  IS_MULTIPLE: 'selectIsMultiple',
  VALUE: 'value',
};
